import _ from "lodash";
import { STATUS_LIST } from "@/constants";
export default {
  methods: {
    mapStatus(s) {
      return _.filter(STATUS_LIST, (status) => {
        return status.number === s;
      })[0].text;
    },
    currentStatus(status) {
      if (status === 1) {
        return "success";
      } else if (status === 2) {
        return "error";
      } else if (status === 3) {
        return "cancel";
      }
      return "warning";
    },
  },
};
